import React, { useEffect, useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { Link, useHistory, withRouter } from "react-router-dom";
import { isEmpty } from "lodash";
import * as moment from "moment";
import axios from "axios";
// import { axiosIns } from '../../utils'
// Import Images
import profileBg from "../../../assets/images/profile-bg.jpg";

import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  ModalFooter,
  Table,
  FormFeedback,
  Button,
  Spinner,
  Badge,
} from "reactstrap";
import Select from "react-select";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

//Import actions
import {
  getAdmins as onGetAdmins,
  addNewAdmin as onAddNewAdmin,
  updateAdmin as onUpdateAdmin,
} from "../../../store/actions";
//redux
import { useSelector, useDispatch } from "react-redux";
import TableContainer from "../../../Components/Common/TableContainer";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import Loader from "../../../Components/Common/Loader";
import axiosInstance from "../../../axiosConfig";

const Admin = (props) => {
  const [loading, setLoading] = useState(true);

  const history = useHistory();
  const dispatch = useDispatch();
  const { admins, isAdminCreated, isAdminSuccess, error } = useSelector(
    (state) => ({
      admins: state.Admin.admins,
      isAdminCreated: state.Admin.isAdminCreated,
      isAdminSuccess: state.Admin.isAdminSuccess,
      error: state.Admin.error,
    })
  );
  const [filteredAdmins, setFilteredAdmins] = useState([]);

  const token = JSON.parse(localStorage.getItem("authUser"))
    ? JSON.parse(localStorage.getItem("authUser")).accessToken
    : null;
  // L'identité du compte connecté : elle sert à ne pas proposer la
  // révocation de son propre accès, que le serveur refuserait de toute façon.
  const utilisateurConnecte = JSON.parse(localStorage.getItem("authUser"))
    ? JSON.parse(localStorage.getItem("authUser")).data
    : null;
  const monUserId = utilisateurConnecte
    ? utilisateurConnecte.user_id ?? utilisateurConnecte.id
    : null;

  const [revocationEnCours, setRevocationEnCours] = useState(null);

  const basculerActivite = useCallback(
    (item) => {
      const desactiver = item.actif !== false;
      const question = desactiver
        ? `Désactiver l'accès de ${item.first_name} ${item.last_name} ? Ses droits sont retirés immédiatement.`
        : `Rétablir l'accès de ${item.first_name} ${item.last_name} ?`;
      if (!window.confirm(question)) return;

      setRevocationEnCours(item.id);
      axiosInstance
        .put(
          `/adminactivite/${item.id}/`,
          { actif: !desactiver },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then((reponse) => {
          toast.success(reponse.data?.message || "Statut modifié", {
            autoClose: 3000,
          });
          dispatch(onGetAdmins());
          handleClick();
        })
        .catch((erreur) => {
          // Le serveur explique pourquoi il refuse — dernier compte actif,
          // ou son propre compte. Ce message vaut mieux qu'un échec générique.
          toast.error(
            erreur.response?.data?.error || "Échec de la modification du statut",
            { autoClose: 5000 }
          );
        })
        .finally(() => setRevocationEnCours(null));
    },
    [dispatch, token]
  );

  const [suppressionEnCours, setSuppressionEnCours] = useState(null);

  const supprimerDefinitivement = useCallback(
    (item) => {
      const attendu = item.email || `${item.first_name} ${item.last_name}`;
      const saisie = window.prompt(
        `Suppression DÉFINITIVE du compte de ${item.first_name} ${item.last_name}.\n\n` +
          `Le profil et l'accès disparaissent ; ses lignes d'historique restent, ` +
          `mais ne désigneront plus personne. Cette action est irréversible — ` +
          `pour une mesure temporaire, utilisez « Révoquer l'accès ».\n\n` +
          `Saisissez « ${attendu} » pour confirmer :`
      );
      // Une frappe volontaire plutôt qu'un simple OK : le geste est sans retour.
      if (saisie === null) return;
      if (saisie.trim() !== attendu) {
        toast.error("Saisie incorrecte — suppression annulée", { autoClose: 4000 });
        return;
      }

      setSuppressionEnCours(item.id);
      axiosInstance
        .delete(`/adminsupprimer/${item.id}/`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((reponse) => {
          toast.success(reponse.data?.message || "Compte supprimé", {
            autoClose: 4000,
          });
          dispatch(onGetAdmins());
          handleClick();
        })
        .catch((erreur) => {
          toast.error(
            erreur.response?.data?.error || "Échec de la suppression",
            { autoClose: 5000 }
          );
        })
        .finally(() => setSuppressionEnCours(null));
    },
    [dispatch, token]
  );

  const [adminList, setAdminList] = useState([]);
  const [reducerValue, forceUpdate] = useReducer((x) => x + 1, 0);

  function handleClick() {
    forceUpdate();
  }

  function formatDate(date) {
    const dateObject = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    });
    return dateObject;
  }

  useEffect(() => {
    if (!isAdminSuccess) {
      dispatch(onGetAdmins());

      // console.log( `token= Bearer ${ token }` );
    }
  }, [isAdminSuccess, dispatch]);

  useEffect(() => {
    // console.log("admins.data: ", admins.data);
    setFilteredAdmins(admins.data);
    setAdmin(admins);
  }, [admins]);

  useEffect(() => {
    if (!isEmpty(admins)) {
      setAdmin(admins);
      setIsEdit(false);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, [admins]);

  const [isEdit, setIsEdit] = useState(false);
  const [admin, setAdmin] = useState([]);

  const [isExportCSV, setIsExportCSV] = useState(false);

  //delete Contact
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [modal, setModal] = useState(false);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setAdmin(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const onClickDelete = (admin) => {
    setAdmin(admin);
    setDeleteModal(true);
  };

  // Add Data
  const handleAdminClicks = () => {
    setAdmin("");
    setIsEdit(false);
    toggle();
  };

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      first_name: (admin && admin.first_name) || "",
      last_name: (admin && admin.last_name) || "",
      email: (admin && admin.email) || "",
      password: (admin && admin.password) || "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required(
        props.t("Veuillez renseigner les prénoms")
      ),
      last_name: Yup.string().required(props.t("Veuillez renseigner le nom")),
      email:
        isEdit === false &&
        Yup.string().required(props.t("Veuillez renseigner l'email")),
      password:
        isEdit === false &&
        Yup.string().required(props.t("Veuillez renseigner le mot de passe")),
    }),
    onSubmit: (values) => {
      // console.log("Edit: ", isEdit);
      if (isEdit) {
        // console.log("values: ", values);

        // const updateAdmin = {
        //   id: admin ? admin.id : 0,
        //   first_name: values.first_name,
        //   last_name: values.last_name,
        //   email: values.email,
        //   password: values.password,
        // };

        const updateAdmin = {
          id: admin ? admin.id : 0,
          first_name: values.first_name,
          last_name: values.last_name,
          email: admin.email,
        };

        // console.log("updateAdmin: ", updateAdmin);

        try {
          // const data = axios.put( `https://stepnode.inawo.pro/admininfoupdate/`, updateAdmin, { headers: { Authorization: `Bearer ${ token }` } } ).then( response =>
          const data = axiosInstance
            .put(`/admininfoupdate/`, updateAdmin, {
              headers: { Authorization: `Bearer ${token}` },
            })
            .then((response) => {
              // dispatch(onUpdateAdmin(updateAdmin));
              validation.resetForm();
              toast.success(props.t("Admin modifié avec succès"), {
                autoClose: 3000,
              });
              dispatch(onGetAdmins());
              handleClick();
            })
            .catch((error) => {
              console.error("Echec de la modification du Admin: ", error);
              toast.error(props.t("Echec de la modification du Admin"), {
                autoClose: 3000,
              });
            });

          // window.location.reload(true);
        } catch (err) {
          console.error("Echec de la modification du Admin: ", err);
          toast.error(props.t("Echec de la modification du Admin"), {
            autoClose: 2000,
          });
        }
        dispatch(onGetAdmins());
      } else {
        // console.log("values: ", values);
        const newAdmin = {
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
          password: values.password,
        };
        // save new Admin
        try {
          const data = axiosInstance
            .post(`/adminregister/`, newAdmin, {
              headers: { Authorization: `Bearer ${token}` },
            })
            .then((response) => {
              // console.log("response adminregister: ", response);
              // dispatch(onAddNewAdmin(newAdmin));
              validation.resetForm();
              toast.success(props.t("Admin successfully added"), {
                autoClose: 3000,
              });
              dispatch(onGetAdmins());
              handleClick();
            })
            .catch((error) => {
              console.error(error);
              toast.error(props.t("Failed to add Admin"), { autoClose: 3000 });
            });
        } catch (err) {
          console.error("Echec d'ajout de l'administrateur: ", err);
          toast.error(props.t("Failed to add Admin"), { autoClose: 3000 });
        }
        dispatch(onGetAdmins());
      }
      toggle();
    },
  });

  // Update Data
  const handleAdminClick = useCallback(
    (arg) => {
      const admin = arg;

      setAdmin({
        id: admin.id,
        first_name: admin.first_name,
        last_name: admin.last_name,
        email: admin.email,
        password: admin.password,
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  // Node API
  useEffect(() => {
    if (isAdminCreated) {
      setAdmin(null);
      dispatch(onGetAdmins());
    }
  }, [dispatch, isAdminCreated]);

  // // Column
  // const columns = useMemo(
  //   () => [
  //     // {
  //     //   Header: <input type="checkbox" id="checkBoxAll" onClick={ () => checkedAll() } />,
  //     //   Cell: ( cellProps ) =>
  //     //   {
  //     //     return <input type="checkbox" className="adminCheckBox" value={ cellProps.row.original.id } />;
  //     //   },
  //     //   id: '#',
  //     // },
  //     {
  //       Header: props.t("Last Name"),
  //       accessor: "last_name",
  //       filterable: false,
  //     },
  //     {
  //       Header: props.t("First Name"),
  //       accessor: "first_name",
  //       filterable: false,
  //     },
  //     {
  //       Header: props.t("Email"),
  //       accessor: "email",
  //       filterable: false,
  //     },
  //     {
  //       Header: props.t("Date d'inscription"),
  //       accessor: "created_at",
  //       filterable: false,
  //       Cell: (cell) => {
  //         return <span>{formatDate(cell.row.original.created_at)}</span>;
  //       },
  //     },
  //     // {
  //     //   Header: props.t( "Action" ),
  //     //   Cell: ( cellProps ) =>
  //     //   {
  //     //     const adminData = cellProps.row.original;
  //     //     return (
  //     //       <ul className="list-inline hstack gap-2 mb-0">
  //     //         <li className="list-inline-item" title={ props.t( "Modifier" ) }>
  //     //           <Link to="#" className="text-warning d-inline-block"
  //     //             onClick={ () => { const adminData = cellProps.row.original; handleAdminClick( adminData ); setIsEdit( true ); toggle(); } }>
  //     //             <i className="ri-pencil-fill align-bottom"></i>
  //     //           </Link>
  //     //         </li>
  //     //       </ul>
  //     //     );
  //     //   },
  //     // },
  //   ],
  //   [handleAdminClick, toggle, props]
  // );

  // SideBar Admin Detail
  const [info, setInfo] = useState([]);
  const [showPassword, setShowPassword] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  useEffect(() => {
    const filtered = (admins.data || []).filter((item) => {
      const fullName = `${item.first_name} ${item.last_name}`.toLowerCase();
      const email = item.email?.toLowerCase() || "";
      return (
        fullName.includes(searchTerm.toLowerCase()) ||
        email.includes(searchTerm.toLowerCase())
      );
    });
    setFilteredAdmins(filtered);
  }, [searchTerm, admins]);

  document.title = props.t("Admins | Takci");
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={props.t("Administrateurs")} pageTitle="Takci" />
          <Row>
            {/* Session Ajout Admin */}
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <div className="d-flex justify-content-end">
                    <div className="flex-shrink-0">
                      <button
                        className="btn add-btn"
                        style={{ background: "#014c94", color: "white" }}
                        onClick={() => {
                          setModal(true);
                        }}
                      >
                        <span className="d-none d-lg-block">
                          <i className="ri-user-add-line me-1 align-bottom"></i>{" "}
                          {props.t("Add Admin")}
                        </span>
                        <span className="d-block d-lg-none">
                          <i className="ri-user-add-line me-1 align-bottom"></i>{" "}
                          {props.t("Admin")}
                        </span>
                      </button>{" "}
                      {isAdminSuccess && admins.data.length > 0 && (
                        <button
                          disabled={!isAdminSuccess && admins.data.length < 0}
                          type="button"
                          className="btn"
                          style={{ color: "#eac22f" }}
                          onClick={() => setIsExportCSV(true)}
                        >
                          <i className="ri-file-download-line align-bottom me-1"></i>{" "}
                          {props.t("Export")}
                        </button>
                      )}
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Col>
            {/* Session Ajout Admin */}

            {/* Session liste des Admins */}
            <Col xxl={12}>
              <div>
                {!loading ? (
                  <>
                    <ExportCSVModal
                      show={isExportCSV}
                      onCloseClick={() => setIsExportCSV(false)}
                      data={
                        isAdminSuccess && admins.data.length > 0
                          ? admins.data
                          : []
                      }
                    />

                    {/* <TableContainer
                          columns={columns}
                          data={
                            isAdminSuccess && admins.data.length > 0
                              ? admins.data
                              : []
                          }
                          isGlobalFilter={true}
                          isAddUserList={false}
                          customPageSize={8}
                          className="custom-header-css"
                          divClass="table-responsive table-card mb-3"
                          tableClass="align-middle table-nowrap"
                          theadClass="table-light"
                          handleAdminClick={handleAdminClicks}
                          isAdminsFilter={
                            !(isAdminSuccess && admins.data.length > 0)
                          }
                        /> */}
                    <Row className="mb-4">
                      <Col>
                        <Input
                          type="text"
                          placeholder="Rechercher..."
                          value={searchTerm}
                          onChange={handleSearch}
                        />
                      </Col>
                    </Row>
                    {searchTerm && (
                      <Col
                        xs={12}
                        className="p-4 border-top border-top-dashed sticky-top"
                      >
                        <h6 className="text-muted text-uppercase fw-semibold text-center mb-3">
                          Resultat de la recherche "{searchTerm}"
                        </h6>
                      </Col>
                    )}
                    <Row className="g-2 mb-3">
                      {filteredAdmins.length > 0 ? (
                        (filteredAdmins || []).map((item, key) => (
                          <Col lg={6} xxl={4} key={key}>
                            <Card className="h-100 w-100">
                              <CardBody className="p-4">
                                <Link
                                  className={`btn btn-sm btn-soft-success position-absolute top-10 end-0 translate-middle fw-bolder rounded shaddow-lg`}
                                  to={`/admin/activity/${item.user_id}`}
                                >
                                  {" "}
                                  Activités
                                </Link>

                                <Row className="align-items-center team-row">
                                  <Col md={4} className="col">
                                    <div className="team-profile-img d-flex justify-content-center">
                                      <div className="avatar-lg img-thumbnail rounded-circle flex-shrink-0">
                                        <div
                                          className={
                                            "avatar-title rounded-circle text-uppercase"
                                          }
                                          style={{
                                            backgroundColor: "#014c94",
                                            color: "#eac22f",
                                          }}
                                        >
                                          {item.first_name.charAt(0) +
                                            item.last_name.charAt(0)}
                                        </div>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md={8} className="col">
                                    <div className="table-responsive">
                                      <Table className="table-borderless mb-0">
                                        <tbody>
                                          <tr>
                                            <th className="ps-0" scope="row">
                                              {props.t("Last Name")}:
                                            </th>
                                            <td className="text-muted">
                                              {item.last_name || (
                                                <Badge color="danger">
                                                  Non renseignée
                                                </Badge>
                                              )}
                                            </td>
                                          </tr>

                                          <tr>
                                            <th className="ps-0" scope="row">
                                              {props.t("First Name")}:
                                            </th>
                                            <td className="text-muted">
                                              {item.first_name || (
                                                <Badge color="danger">
                                                  Non renseignée
                                                </Badge>
                                              )}
                                            </td>
                                          </tr>

                                          <tr>
                                            <th className="ps-0" scope="row">
                                              {props.t("Email")}:
                                            </th>
                                            <td className="text-muted">
                                              {(item.email && (
                                                <a
                                                  href={`mailto: ${item.email}`}
                                                >
                                                  {item.email}
                                                </a>
                                              )) || (
                                                <Badge color="danger">
                                                  Non renseignée
                                                </Badge>
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <th className="ps-0" scope="row">
                                              Adhésion
                                            </th>
                                            <td className="text-muted">
                                              {(item.created_at &&
                                                formatDate(
                                                  item.created_at
                                                )) || (
                                                <Badge color="danger">
                                                  Non renseignée
                                                </Badge>
                                              )}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </Table>
                                    </div>
                                  </Col>
                                </Row>

                                <div className="d-flex align-items-center justify-content-between mt-3 pt-3 border-top border-top-dashed">
                                  <Badge
                                    color={item.actif === false ? "danger" : "success"}
                                    className="fs-11"
                                  >
                                    {item.actif === false ? "Accès révoqué" : "Actif"}
                                  </Badge>

                                  <div className="d-flex gap-2">
                                  {item.user_id !== monUserId && (
                                    <button
                                      type="button"
                                      className={`btn btn-sm ${
                                        item.actif === false
                                          ? "btn-soft-success"
                                          : "btn-soft-danger"
                                      }`}
                                      disabled={revocationEnCours === item.id}
                                      onClick={() => basculerActivite(item)}
                                    >
                                      {revocationEnCours === item.id
                                        ? "Patientez…"
                                        : item.actif === false
                                        ? "Rétablir l'accès"
                                        : "Révoquer l'accès"}
                                    </button>
                                  )}

                                  {item.user_id !== monUserId && (
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-danger"
                                      disabled={suppressionEnCours === item.id}
                                      onClick={() => supprimerDefinitivement(item)}
                                    >
                                      {suppressionEnCours === item.id
                                        ? "Suppression…"
                                        : "Supprimer"}
                                    </button>
                                  )}
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                        ))
                      ) : (
                        <Col
                          xs={12}
                          className="p-4 border-top border-top-dashed"
                        >
                          <h6 className="text-muted text-uppercase fw-semibold text-center">
                            Aucun admin disponible
                          </h6>
                        </Col>
                      )}
                    </Row>
                  </>
                ) : (
                  <div className="text-center my-3">
                    {/* <Spinner size="sm" className=''
                            style={ { color: '#014c94' } }
                          /> */}
                    <Loader style={{ color: "#014c94" }} />
                    <h2>Chargement...</h2>
                  </div>
                )}
              </div>

              <Modal id="showModal" isOpen={modal} centered>
                <ModalHeader className="bg-soft-info p-3">
                  {isEdit === true
                    ? `${props.t("Edit")} Admin `
                    : props.t("Add Admin")}
                </ModalHeader>

                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <ModalBody>
                    <Input type="hidden" id="id-field" />
                    <Row className="g-3">
                      <Col lg={6}>
                        <div>
                          <Label
                            htmlFor="last_name-admin"
                            className="form-label"
                          >
                            {props.t("Last Name")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            name="last_name"
                            id="last_name-admin"
                            className="form-control"
                            placeholder={props.t("Enter Last Name")}
                            type="text"
                            validate={{
                              required: { value: true },
                            }}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.last_name || ""}
                            invalid={
                              validation.touched.last_name &&
                              validation.errors.last_name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.last_name &&
                          validation.errors.last_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.last_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div>
                          <Label
                            htmlFor="first_name-admin"
                            className="form-label"
                          >
                            {props.t("First Name")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            name="first_name"
                            id="first_name-admin"
                            className="form-control"
                            placeholder={props.t("Enter First Name")}
                            type="text"
                            validate={{
                              required: { value: true },
                            }}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.first_name || ""}
                            invalid={
                              validation.touched.first_name &&
                              validation.errors.first_name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.first_name &&
                          validation.errors.first_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.first_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>

                      {isEdit === false && (
                        <>
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="email-admin"
                                className="form-label"
                              >
                                {props.t("Email")}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <Input
                                name="email"
                                id="email-admin"
                                className="form-control"
                                placeholder={props.t("Enter Email")}
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.email || ""}
                                invalid={
                                  validation.touched.email &&
                                  validation.errors.email
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.email &&
                              validation.errors.email ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.email}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="password-admin"
                                className="form-label"
                              >
                                {props.t("Password")}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </Label>
                              <div className="position-relative auth-pass-inputgroup mb-3">
                                <Input
                                  type={showPassword ? "text" : "password"}
                                  name="password"
                                  id="password-admin"
                                  className="form-control"
                                  placeholder={props.t("Enter Password")}
                                  validate={{
                                    required: { value: true },
                                  }}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.password || ""}
                                  invalid={
                                    validation.touched.password &&
                                    validation.errors.password
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.password &&
                                validation.errors.password ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.password}
                                  </FormFeedback>
                                ) : null}

                                <button
                                  onClick={() => setShowPassword(!showPassword)}
                                  className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                  type="button"
                                  id="password-addon"
                                >
                                  {showPassword ? (
                                    <i className="ri-eye-off-fill align-middle"></i>
                                  ) : (
                                    <i className="ri-eye-fill align-middle"></i>
                                  )}
                                </button>
                              </div>
                            </div>
                          </Col>
                        </>
                      )}
                    </Row>
                  </ModalBody>
                  <ModalFooter>
                    <div className="hstack gap-2 justify-content-end">
                      <Button
                        type="button"
                        onClick={() => {
                          setModal(false);
                          // dispatch( onGetAdmins() );
                        }}
                        className="btn-light"
                      >
                        {props.t("Close")}
                      </Button>
                      {/* <button type="button" className="btn btn-light" onClick={() => { setModal(false);dispatch(onGetAdmins); }} > {props.t("Fermer")} </button> */}
                      <button
                        type="submit"
                        className="btn"
                        style={{ background: "#002437", color: "white" }}
                        id="add-btn"
                      >
                        {!!isEdit ? props.t("Edit") : props.t("Add Admin")}
                      </button>
                    </div>
                  </ModalFooter>
                </Form>
              </Modal>

              <ToastContainer closeButton={false} />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Admin.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(Admin));
